import React, { useEffect, useState } from "react";
import Modal from "react-modal"
import { adminServices } from "../../services/AdminServices";
import InputText1 from '../InputText1';
import InputText2 from '../InputText2';
import Button from '../Button';
import LoadingModal from "../LoadingModal";
import { generateCompliantPassword, validatePassword } from "../../tools/passwordPolicy";
const customStyles = { 
    overlay: { 
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
    }, 
    content: {
        width: '800px', 
        margin: 'auto', 
        maxHeight: '50vh',
        overflow: 'auto'
    },
 };

const UserFormComponent = ({show,onClose,data = null, onAfterSubmit, onError})=>{
    const [validateMessage, setValidateMessage] = useState("Please fill all fields");  
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");
    const [selectedRole, setSelectedRole] = useState(0);
    const [isAdmin, setIsAdmin] = useState(0);
    const [validated, setValidated] = useState(false);
    const [loading, setLoading] = useState(false);
    const [password, setPassword] = useState("");
    const [userId, setUserId] = useState(0);
    const [roles, setRoles] = useState([]);

    useEffect(()=>{
        getRoles();
    },[]);

    useEffect(()=>{
        if(data){
            setFirstName(data.firstName);
            setLastName(data.lastName);
            setEmail(data.emailAddress);
            setMobileNumber(data.mobileNumber);
            setIsAdmin(data.isAdmin == 'Yes' ? 1 : 0);
            setSelectedRole(data.role_id);
            setUserId(data.user_id);
        }
        else{
            setFirstName("");
            setLastName("");
            setEmail("");
            setMobileNumber("");
            setIsAdmin(null);
            setSelectedRole(0);
            setValidated(false);
        }
    },[data]);

    const getRoles = async() => {
        await adminServices.storeProcedure2("getUserRoles",{}).then(response => {
          if(response.status === 200){
            setRoles(response.data);
          }
        }).catch(error => {
          if(error.status === 401){
            window.location.href = "/";
          }
        })
      };

    const validateForm = () => {
        if(firstName == "" || lastName == "" || email == "" || mobileNumber == "" || selectedRole == 0){
            setValidateMessage('Please fill all fields');
          return false;   
        }

        const mobileNumberPattern = /^0\d{10}$/; 
        if (!mobileNumberPattern.test(mobileNumber)) 
        { 
            setValidateMessage('Invalid Mobile Number');
        
            return false;
        }

        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; 
        if (!emailPattern.test(email)) 
        { 
            setValidateMessage('Invalid Email Address');
            return false;
        }

        return true;
    }

    const emailCreds = async (newPass)=>{
        var formData = new FormData();
        formData.append("EmailAddress",email);
        formData.append("Password",newPass);
        setLoading(true);
        await adminServices.emailCredentials(formData).then(response => {
            if(response.status === 200){
                onAfterSubmit(newPass);
                onClose();
                setLoading(false);
            }
        }).catch(error => {
            if(error.status === 401){
                window.location = "/";
            }
            //console.log(error);
        });
    }

    const handleSubmit = async () => {
        if(validateForm()){
            setLoading(true);
            let form = new FormData();
            
            let newPassword = generateCompliantPassword(12);
            setPassword(newPassword);

            if(data == null){
                form.append("params",`'${firstName}','${lastName}','${email}','${newPassword}','${mobileNumber}',1,${selectedRole},${selectedRole},1,${isAdmin}`); 
                let params = {
                    firstName: firstName,
                    lastName: lastName,
                    emailAddr: email,
                    password: newPassword,
                    mobileNumber: mobileNumber,
                    isActive: 1,
                    roleId: selectedRole,
                    isAdmin: isAdmin
                }   
                adminServices.storeProcedure2("AddUser",params).then(response => {
                    if(response.data[0].message != "User already exists"){
                        emailCreds(newPassword);
                        
                    }else{
                        onAfterSubmit("409");
                        setLoading(false);
                    }
                }).catch(error => {
                    if(error.status == 401){
                        window.location = "/";
                    }
                    
                    onError();
                    onClose();

                })
            }
            else{
                let params = {
                    userId: userId,
                    firstName: firstName,
                    lastName: lastName,
                    emailAddr: email,
                    mobileNumber: mobileNumber,
                    isAdmin: isAdmin,
                    roleId: selectedRole
                } 
                adminServices.storeProcedure2("UpdateUser",params).then(response => {
                    //console.log(response);
                    if(response.data[0].message == "Successfully Updated"){
                        onClose();
                        onAfterSubmit("204");
                    }else{
                        onClose();
                        onAfterSubmit("406");

                    }
                }).catch(error => {
                    if(error.status == 401){
                        window.location = "/";
                    }
                    
                    onError();
                    onClose();

                }).finally(()=>{
                    setLoading(false);
                });
            }
            
        }
        else{
            setValidated(true);
        }
    }

    return (
        <Modal
            
            isOpen={show}
            shouldCloseOnEsc={false} 
            shouldCloseOnOverlayClick={false}
            style={customStyles}
            onRequestClose={onClose}
        >
         <LoadingModal show={loading} message={"Saving data..."} />
        <div className="user-management-modal-content">
         <div style={{display:"flex",justifyContent:'space-between',zIndex:999}} className="mb-3">
                <h3>User Management</h3>
                <button style={{backgroundColor:'#fff',
                    borderColor:'#d2d2d2',
                    color:'#555',
                    borderRadius:100,
                    fontSize:20,
                    fontWeight: 'bolder',
                    fontFamily: 'monospace',
                    borderWidth:0}}
                    onClick={onClose}
                    >
                        x
                    </button>
            </div>

            {/* Password policy banner */}
            {/* <div className="password-policy-banner" style={{background:'#f1f9ff',border:'1px solid #dbeffd',padding:12,borderRadius:6,marginBottom:12}}>
                <strong>Password Requirements (Auto-Generated):</strong>
                <ul style={{marginTop:8,marginBottom:0,paddingLeft:18}}>
                    <li>Minimum 8 characters</li>
                    <li>At least 1 uppercase letter (A-Z)</li>
                    <li>At least 1 lowercase letter (a-z)</li>
                    <li>At least 1 number (0-9)</li>
                    <li>At least 1 special character (e.g. !@#$%^&*)</li>
                </ul>
            </div> */}

            {/* Validation error message at top */}
            {validated && (
                <div style={{color:'#8b0000',background:'#fff5f5',border:'1px solid #f5c6cb',padding:10,borderRadius:6,marginBottom:12}}>
                    <strong>Please fix the following:</strong>
                    <p style={{marginTop:6,marginBottom:0}}>{validateMessage}</p>
                </div>
            )}

            {/* Row 1: First Name, Last Name, Email */}
            <div className="flexRow">
                <InputText1 title={"First Name*"} value={firstName} onChange={(e)=>{ setFirstName(e.target.value) }} />
                <InputText1 title={"Last Name*"} value={lastName} onChange={(e)=>{ setLastName(e.target.value) }} />
                <InputText1 title={"Email Address*"} value={email} onChange={(e)=>{ setEmail(e.target.value) }} />
            </div>

            {/* Row 2: Mobile Number, Role, Super User */}
            <div className="flexRow">
                <InputText1 title={"Mobile Number*"} value={mobileNumber} onChange={(e)=>{ setMobileNumber(e.target.value) }} />
                <div style={{ margin: "20px", flex: "2" }}>
                    <p className="semibold ">{"Role*"}</p>
                    <select className="form-control" style={{width:'200px'}} value={selectedRole} onChange={(e)=>{ setSelectedRole(e.target.value) }} >
                        <option value={0} selected disabled>Select a Role</option>
                        {roles && roles.map((role,index) => {
                            return <option key={index} value={role.role_id}>{role.role_name}</option>
                        })}
                    </select>
                </div>
                <div style={{ margin: "5px", flex: "2" }}>
                    <p className="semibold ">{"Is Super User?"}</p>
                    <select className="form-control" style={{width:'200px'}} value={isAdmin} onChange={(e)=>{ setIsAdmin(e.target.value) }} >
                        <option value={0}>No</option>
                        <option value={1}>Yes</option>
                    </select>
                </div>
            </div>

            {/* Action buttons */}
            <div className="flexRow" style={{justifySelf:'end'}}>
                    <Button variant={"success"} size={'md'} onClick={handleSubmit}>
                        Submit
                    </Button>
                    &nbsp;
                    <Button variant={"secondary"} size={'md'} onClick={onClose}>
                        Cancel
                    </Button>
            </div>
        </div>
        </Modal>
    )
}

export default UserFormComponent;